export default {
  setScreenId(state, payload) {
    console.log('mutation', payload)
    state.screen_id = payload.screen_id
  }
}
